import { Box, Typography } from '@mui/material';
import { useStyles } from '../styles';
import DOMPurify from 'dompurify';

type FormContentSectionProps = {
  children: any;
  isMobile: boolean;
  title: string;
  description: string;
};

export const FormContentSection = ({ children, isMobile, title, description }: FormContentSectionProps) => {
  const classes = useStyles();
  return (
    <Box>
      <Box>
        <div className={classes.description}>
          <Typography variant="h5" sx={{ my: 2 }}>
            {title}
          </Typography>
          <Typography
            variant="subtitle1"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description)
            }}
          ></Typography>
        </div>
      </Box>
      <Box display="flex" sx={{ gap: 2 }} flexDirection={isMobile ? 'column' : 'row'}>
        {children}
      </Box>
    </Box>
  );
};
